export default {
	titre: 'Retrouvez tous vos conseils prévention dans Mon espace santé',
	texte: 'Bénéficiez d\'un agenda personnalisé pour vous informer des prochains examens et vaccinations à réaliser pour vous et vos enfants. Disposez également de conseils adaptés à vos besoins pour adopter les bons réflexes et agir pour votre santé. En savoir plus sur ',
	lien: {
		texte: 'Mon espace santé',
		href: 'https://www.monespacesante.fr/',
		ariaLabel: 'Lien vers le site Mon espace santé dans un nouvel onglet.'
	},
	point: '.'
};
